<template>
  <div class="footer-logo-fixed" v-show="visible" @mouseleave="visible = false">
    <img src="@/assets/img/eu-fund-flags.svg" alt="EU fund flags" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: true
    }
  },
  created() {
    setTimeout(() => (this.visible = false), 7000)
  }
}
</script>

<style scoped>
.footer-logo-fixed {
  display: block;
  position: fixed;
  background: #fff;
  bottom: 0;
  left: 0;
  margin: 0;
  padding: 5px 20px;
  text-align: center;
  z-index: 1000;
}

.footer-logo-fixed img {
  width: 86px;
}
</style>
